import vue from "vue";
import localForage from "localforage";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_MEDICAL_SPECIALTIES: async (state, payload) => {
        if(!payload.items) {
            await localForage.setItem('medicalSpecialties',_.cloneDeep(payload.medicalSpecialties));
            if(payload.version) {
                await localForage.setItem('medical-specialties-version', payload.version);
            }
            vue.set(state, 'medicalSpecialties', payload.medicalSpecialties);
        }
        else vue.set(state, 'medicalSpecialties', payload.items);
    },
    SET_MEDICAL_SPECIALTY: (state, medicalSpecialty) => {
        state.medicalSpecialty = medicalSpecialty;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_MEDICAL_SPECIALTY_TO_EDIT: (state, medicalSpecialtyToEdit) => {
        state.medicalSpecialtyToEdit = medicalSpecialtyToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
}